import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function IncludesSection() {
  const includes = ['Protocolo 21 días (Calma → Barrera → Brotes)', 'Rutina mínima "5 minutos" (mañana/noche + versión sensible)', 'Checklist "Lista Negra" (lo que te reinicia el problema)', 'Tracker 21 días para detectar detonantes sin obsesionarte', 'Mini protocolo de emergencia: qué hacer las próximas 72 horas', 'Señales claras para saber cuándo escalar a dermatóloga'];
  return <section className="py-24 px-4 bg-[#FBF7F4]" id="producto" data-id="element-92">
      <div className="max-w-6xl mx-auto" data-id="element-93">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-94">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="order-2 md:order-1" data-id="element-95">
            <img src="https://cdn.magicpatterns.com/uploads/uajYsPvrnjTvTdcyuyFQ3k/mockup-1,_piel-perry.png" alt="PIEL EN PERI Tablet Mockup" className="w-full h-auto rounded-lg shadow-2xl shadow-[#8B7355]/20" data-id="element-96" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="order-1 md:order-2" data-id="element-97">
            <h2 className="text-3xl md:text-4xl font-serif text-[#2D2A26] mb-8" data-id="element-98">
              ¿Qué incluye?
            </h2>
            <div className="space-y-4" data-id="element-99">
              {includes.map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex items-start gap-4 p-4 bg-white rounded-sm border border-[#8B7355]/10" data-id="element-100">
                  <div className="bg-[#C4A08A]/20 p-1 rounded-full mt-0.5" data-id="element-101">
                    <Check className="w-4 h-4 text-[#C4A08A]" data-id="element-102" />
                  </div>
                  <span className="text-[#2D2A26]/80 font-medium" data-id="element-103">{item}</span>
                </motion.div>)}
            </div>

            <div className="mt-10 p-8 bg-[#C4A08A] text-white rounded-sm text-center" data-id="element-104">
              <p className="text-sm uppercase tracking-widest opacity-80 mb-2" data-id="element-105">
                Oferta de lanzamiento
              </p>
              <div className="flex items-center justify-center gap-3 mb-1" data-id="element-106">
                <span className="text-lg line-through opacity-60" data-id="element-107">
                  $19.99 USD
                </span>
                <span className="font-serif text-4xl md:text-5xl font-bold" data-id="element-108">
                  $6.39 USD
                </span>
              </div>
              <p className="text-sm opacity-80 mb-5" data-id="element-109">
                PDF Digital · Acceso Inmediato · Garantía 7 días
              </p>
              <a href="https://pay.hotmart.com/M104466363F" target="_blank" rel="noopener noreferrer" onClick={() => {
              if (typeof window !== 'undefined' && window.fbq) {
                window.fbq('track', 'AddToCart', {
                  content_name: 'PIEL EN PERI Protocolo',
                  content_type: 'product',
                  value: 6.39,
                  currency: 'USD'
                });
              }
            }} className="inline-block w-full bg-white text-[#8B7355] font-semibold text-lg px-8 py-4 rounded-sm hover:bg-[#FBF7F4] transition-colors duration-300 shadow-lg shadow-black/10" data-id="element-110">
                Quiero mi protocolo por $6.39
              </a>
              <p className="mt-3 text-xs opacity-70" data-id="element-111">
                🔒 Pago seguro · Descarga y empieza hoy mismo
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}